import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { NavLinkTab } from 'Shared';
import { createUseStyles } from 'react-jss';

import { isAdminSelector, isLocalAdminSelector } from 'Services/auth.service';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { settingsStyles } from './useStyles';

const useStyles = createUseStyles({
  settings: {
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
    height: '100%',
    overflowY: 'hidden',
  },
  settings_tabs: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'start',
    gap: '.5rem',
    padding: '.5rem .25rem',
    backgroundColor: '#F3F3F7',
    borderBottom: ' 1px solid #E7E7EF',
    boxShadow: '0 4px 8px -5px rgba(0, 0, 0, .65)',
    zIndex: 1,
    overflowX: 'auto',
  },
  settings_tab: {
    ...settingsStyles.settings_tab,
  },
  settings_content: {
    display: 'grid',
    overflow: 'auto',
  },
});

export const SettingsTopBar = React.memo(() => {
  const classes = useStyles();

  return (
    <div className={classes.settings}>
      <SettingsTabs />

      <div className={classes.settings_content}>
        <Suspense fallback={<SuspenseSpinner />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
});
SettingsTopBar.displayName = 'SettingsTopBar';

export const SettingsTabs = React.memo(() => {
  const classes = useStyles();
  const isAdmin = useSelector(isAdminSelector);
  const isLocalAdmin = useSelector(isLocalAdminSelector);

  const settingsTabs = React.useMemo(() => [
    {
      to: 'common',
      name: 'Настройки',
      canSee: isAdmin,
    },
    {
      to: 'users',
      name: 'Пользователи',
      canSee: (isAdmin || isLocalAdmin),
    },
    {
      to: 'software',
      name: 'Программное обеспечение',
      canSee: isAdmin,
    },
    {
      to: 'journals',
      name: 'Журналы',
      canSee: (isAdmin || isLocalAdmin),
    },
  ], [isAdmin, isLocalAdmin]);

  return (
    <div className={classes.settings_tabs}>
      {
        settingsTabs.map(({ to, name, canSee }) => (
          canSee && <NavLinkTab key={to} to={to} className={classes.settings_tab}>{name}</NavLinkTab>
        ))
      }
    </div>
  );
});
SettingsTabs.displayName = 'SettingsTabs';
